import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { CITY_GUIDES } from "@/data/cityGuides";

/** SEO hub-link grid to all 25 "lawyer in <city>" guide pages — placed at the
 * bottom of /advice and /supreme-court-lawyers so every city guide page is
 * reachable in a couple of clicks from the two highest-traffic pages. */
export function CityHubLinks() {
  return (
    <section className="border-t bg-secondary/20" data-testid="city-hub-links-section">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6">
        <h2 className="font-serif text-xl font-bold tracking-tight sm:text-2xl">
          Find a Lawyer & Court Guide by City (25 Cities)
        </h2>
        <p className="mt-1.5 max-w-2xl text-sm text-muted-foreground">
          Free legal guidance, District &amp; High Court jurisdiction, and matched Supreme Court advocates for litigants in your city.
        </p>
        <div className="mt-5 grid grid-cols-2 gap-2.5 sm:grid-cols-3 md:grid-cols-5">
          {CITY_GUIDES.map((c) => (
            <Link
              key={c.slug}
              to={`/legal-help/lawyer-in-${c.slug}`}
              className="inline-flex items-center gap-1.5 rounded-lg border bg-card px-3 py-2 text-sm font-medium text-foreground transition-colors hover:border-primary/40 hover:text-primary"
              data-testid={`city-hub-link-${c.slug}`}
            >
              <MapPin className="h-3.5 w-3.5 shrink-0 text-primary" /> <span className="truncate">Lawyer in {c.city}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CityHubLinks;
